import { fromJS } from 'immutable';
import { STATE_NAME } from './constants';

export const getStateSlice = state => state.get(STATE_NAME);

export const getIsSignedIn = state => getStateSlice(state).get('isSignedIn');

export const getIsAuthenticating = state =>
  getStateSlice(state).get('isAuthenticating');

export const getAuthenticateError = state =>
  getStateSlice(state).get('authenticateError');

export const getLoadCachedUserAttempted = state =>
  getStateSlice(state).get('loadCachedUserAttempted');

export const getUser = state => getStateSlice(state).get('user') || fromJS({});

export const getUserMarkets = state => getUser(state).get('ppsiMarkets') || [];

export const getIsGlobalUser = state => getUser(state).get('ifsUser');

export const getIsLocalUser = state => !getUser(state).get('ifsUser');

export const getIsPPSIEnabledUser = state => {
  const user = getUser(state);
  return user.size === 0 || user.get('ppsiEnabled');
};

export const getShouldReauthenticate = state =>
  getStateSlice(state).get('reauthenticate');
